import { h } from 'preact';
import { VOID_FN } from '../../../../../utils';
import { useStyles } from '../../../../common/hooks';
import { getStyles } from '../../common/slider/getStyles';

function LiveCursor({
  position,
  strokeSize,
  cursorSize,
  live,
  timeshifting,
  hidden,
  onClick = VOID_FN,
  style = {}
}) {
  const styles = getStyles({
    strokeSize,
    cursorSize
  });

  return (!hidden && (
    <div
      onClick={(e) => { e.stopPropagation(); onClick(); }}
      style={{
        ...position,
        ...(live && timeshifting ? useStyles()(styles.expectedCursor) : styles.liveCursor),
        ...style
      }}
      role="presentation"
    />
  ));
}

export default LiveCursor;
